export const FLAG_GETTING_FUEL_STATIONS = 'FLAG_GETTING_FUEL_STATIONS';
export const GET_FUEL_STATIONS = 'GET_FUEL_STATIONS';
export const CLEAR_FUEL_STATIONS = 'CLEAR_FUEL_STATIONS';
export const FLAG_FUEL_STATION_ACTIVITY = 'FLAG_FUEL_STATION_ACTIVITY';
export const GET_FUEL_STATION = 'GET_FUEL_STATION';
export const CLEAR_FUEL_STATION = 'CLEAR_FUEL_STATION';
export const POST_FUEL_STATION = 'POST_FUEL_STATION';
export const PUT_FUEL_STATION = 'PUT_FUEL_STATION';
